import styles from './Requirements.section.module.css'
import { Trash } from 'lucide-react'
import dragIcon from '@/assets/dragIcon.svg'
import { useRequirements, useRequirementsMutations } from '../../../../hooks/templates/requirements/useRequirements'
import { useDroppable } from '@dnd-kit/react'

type Props = {
  selectedCategoryId: number | null
  selectedTagId: number | null
  selectedTagIsBase: boolean
  isDragOver: boolean
}

export default function RequirementsSection({isDragOver, selectedCategoryId, selectedTagId, selectedTagIsBase}: Props) {    
  
  const {data: requirements} = useRequirements(selectedCategoryId, selectedTagId)  
  const { deleteRequirement  } = useRequirementsMutations()

  const {ref} = useDroppable({ id: "requirements-section" })    
  
  
  const handleDeleteRequirement = (requirementId: number) => {    
    if(!selectedCategoryId || !selectedTagId ) return
    
    deleteRequirement.mutate({
      categoryId: selectedCategoryId,
      requirementId: requirementId,
      tagId: selectedTagId      
    })
  }

  return (
    <div ref={ref} className={`${styles.requirements} ${isDragOver ? styles.dragOver : ""}`}>                                
        { selectedCategoryId === null ?

            <div className={styles.empty}>
              <span>
              Selecciona una categoria para ver sus etiquetas y requerimientos
              </span>
            </div>
          : 
            <>
              <span className={styles.title}>Requerimientos</span>
              <div className={styles.separatorh}></div>
              
              { requirements ? 
                  requirements.length > 0 ? (              
                    <div className={styles.list}>
                      {requirements.map(requirement => (
                        <div 
                          key={`requirement-${requirement.id}`}
                          className={`${styles.requirement} ${requirement.hasTagBase && !selectedTagIsBase ? styles.tagBase : ""}`} 
                        >                      
                            <span>{requirement.documentName}</span>                      
                            
                            <div className={styles.options}>
                                <div className={styles.option} 
                                        onClick={() => handleDeleteRequirement(requirement.id)}
                                > 
                                    <Trash width={16} height={16}/> 
                                </div>
                            </div>
                        </div>                                      
                      ))}
                    </div>
                  ) : (                        
                    <div className={styles.empty}>
                      <img src={dragIcon} alt="empty" width={200} height={200} />
                      <span>
                        Arrastra documentos desde la sección de la derecha para añadirlos como requerimientos
                      </span>
                    </div>       
                  )                                        
                : 
                  <></>
              }
            </>         
        }

    </div>    
  )
}
